import DispatchConstants from 'app/shared/constants/DispatchConstants';

const RentGuaranteeActions = {
    setMonthlyRent(monthlyRent) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_MONTHLY_RENT,
            payload: monthlyRent,
        });
    },
    setSecurityDeposit(securityDeposit) {
        return dispatch => dispatch({
            type: DispatchConstants.RENT_GUARANTEE_UPDATE_SECURITY_DEPOSIT,
            payload: securityDeposit,
        });
    },
};

export default RentGuaranteeActions;
